import { Observable, Subject } from "rxjs";

export class ReviewInputPositionObservableService {
    private dataSubject = new Subject<any>();
    public $data: Observable<any> = this.dataSubject.asObservable();

    constructor(){}

    public emitData(data:any) {
        this.dataSubject.next(data)
    }
}